import React, { useState, useEffect } from 'react';
import './VetShiftSchedule.css';
import { useSelector, useDispatch } from 'react-redux';
import { fetchDoctorDashboardData } from '../../../../redux/reducers/doctorDashboardSlice';
const shiftColors = {
  available: 'available',
  leave: 'absent',
  not_scheduled: 'not-scheduled',
};

const dayKeys = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
const displayDays = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];

const VetShiftSchedule = () => {
  const dispatch = useDispatch();
  const { vetShif, loading } = useSelector((state) => state.doctorDashboard);
  const [shiftType, setShiftType] = useState('virtual'); // default selection
  const [scheduleData, setScheduleData] = useState([]);

  useEffect(() => {
    dispatch(fetchDoctorDashboardData());
  }, [dispatch]);

  useEffect(() => {
    if (!vetShif.length) return;

    const filtered = vetShif.filter(
      (item) => item.type.toLowerCase() === shiftType.toLowerCase()
    );

    const schedule = filtered.map((entry) => ({
      name: entry.doctorName,
      shifts: dayKeys.map((day) => entry.schedule[day] || 'not_scheduled'),
    }));

    setScheduleData(schedule);
  }, [vetShif, shiftType]);

  return (
    <div className="container">
     
      <div className="title-header">
  <h2 className="title">
    Vet Shift Schedule ({shiftType.charAt(0).toUpperCase() + shiftType.slice(1)})
  </h2>
  <select
    className="view-select"
    value={shiftType}
    onChange={(e) => setShiftType(e.target.value.toLowerCase())}
  >
    <option value="virtual">Virtual</option>
    <option value="home">Home</option>
    <option value="physical">Physical</option>
  </select>
</div>


      <div className="legend">
        <div className="legend-item">
          <span className="dot available"></span>Available
        </div>
        <div className="legend-item">
          <span className="dot absent"></span>Leave
        </div>
        <div className="legend-item">
          <span className="dot not-scheduled"></span>Not scheduled
        </div>
      </div>

      <div className="table-wrapper">
        <table className="schedule-table">
          <thead>
            <tr>
              <th>Vet</th>
              {displayDays.map((day) => (
                <th key={day}>{day}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {scheduleData.map((vet) => (
              <tr key={vet.name}>
                <td className="vet-name">{vet.name}</td>
                {vet.shifts.map((shift, idx) => (
                  <td key={idx}>
                    <div className={`cell ${shiftColors[shift] || 'not-scheduled'}`}>
                      {shift === 'available'
                        ? '✓'
                        : shift === 'leave'
                        ? 'L'
                        : shift === 'not_scheduled'
                        ? '-'
                        : shift}
                    </div>
                  </td>
                ))}
              </tr>
            ))}
            {scheduleData.length === 0 && !loading && (
              <tr>
                <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                  No data available for "{shiftType}" shift.
                </td>
              </tr>
            )}
            {loading && (
              <tr>
                <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                  Loading...
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VetShiftSchedule;